import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";


const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
};
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const getFCMToken = async () => {
    try {
        // 1- Register service worker
        const swReg = await navigator.serviceWorker.register('/firebase-messaging-sw.js', { type: 'module' });
        // 2- Get Token
        const token = await getToken(messaging, {
            vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
            serviceWorkerRegistration: swReg
        });
        return token;
    } catch (error) {
        console.error("Error getting FCM token:", error);
        throw error;
    }
};


export {
    getFCMToken,
    messaging,
    onMessage
};